export default __webpack_public_path__ + "static/media/b5589099ce3215c6ad7d36fe4b18fc83.03a80d5a.png";